import React, {useEffect, useState} from "react";
import {Alert, Button, DatePicker, Modal, Select, Space} from "antd";
import {useTranslate} from "../../../../hooks/translate.hook";
import {loggerService} from "../../../../services/logger/logger.service";
import {ChangeLog} from "../../../../models/logger/logger.data";
import {LoadingSpin} from "../../../common/loading-spin/loading.spin";
import {ChangesTable} from "../result/result";
import dayjs from "dayjs";

export interface ChangeLogEntityDef {
    id: string;
    name: string;
}

interface ChangeLogModalProps {
    onClose: () => void;
    entities: ChangeLogEntityDef[]
}

export const ChangeLogModal: React.FC<ChangeLogModalProps> = ({entities, onClose}) => {

    const [entity, setEntity] = useState<ChangeLogEntityDef>(entities[0]);
    const t = useTranslate();

    const [fields, setFields] = useState<string[]>([]);
    const [changes, setChanges] = useState<ChangeLog[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [dates, setDates] = useState<[start: dayjs.Dayjs, end: dayjs.Dayjs]>([
        dayjs().subtract(4, 'year').startOf('day'),
        dayjs().startOf('day')
    ])

    const setDatesFrom = (value: number, unit: dayjs.ManipulateType) => {
        setDates([
            dayjs().subtract(value, unit).startOf('day'),
            dayjs().startOf('day')
        ])
    }

    useEffect(() => {
        setLoading(true)
        Promise.all([
            loggerService.getChangeLogFields(entity.name).then(resp => setFields(resp.fields)),
            loggerService.getChangeLogs(
                entity.name,
                entity.id,
                dates[0].format("YYYY-MM-DD"),
                dates[1].format("YYYY-MM-DD")
            ).then(resp => setChanges(resp.result))
        ]).then(() => setLoading(false))
    }, [entity, dates]);

    return (
        <Modal

            open
            title={"Change Log"}
            onCancel={onClose}
            footer={null}
            width="100vw"
            style={{
                top: 0,
                paddingBottom: 0,
                maxWidth: '100vw',
            }}
            styles={{
                content: {
                    height: '100vh',
                    borderRadius: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                },
                header: {
                    padding: '16px 24px',
                    margin: 0,
                    borderBottom: '1px solid #f0f0f0',
                },
                body: {
                    flex: 1,
                    overflow: 'auto',
                    padding: '0 24px',
                },
            }}
        >
            {loading ? (
                <LoadingSpin />
            ) : (
                <Space direction={"vertical"} size={[10, 10]}>
                    <Space direction={"horizontal"} size={[10, 10]}>
                        {entities.length > 1 ? (
                            <Select
                                style={{width: "400px"}}
                                options={entities.map(e => ({
                                    label: e.name + ' : ' + e.id,
                                    value: e.name
                                }))}
                                value={entity.name}
                                onChange={(value) => {
                                    const ref = entities.find(e => e.name === value)
                                    if (ref) {
                                        setEntity(ref);
                                    }
                                }}
                            />
                        ) : null}
                        <DatePicker.RangePicker
                            value={dates}
                            onChange={dates => setDates(dates as any)}
                        />
                        <Button onClick={() => setDatesFrom(0, 'days')}>
                            Today
                        </Button>
                        <Button onClick={() => setDatesFrom(1, 'week')}>
                            Last week
                        </Button>
                        <Button onClick={() => setDatesFrom(1, 'month')}>
                            Last month
                        </Button>
                        <Button onClick={() => setDatesFrom(1, 'year')}>
                            Last year
                        </Button>
                        <Button onClick={() => setDatesFrom(5, 'year')}>
                            Last 5 years
                        </Button>
                    </Space>
                    {changes.length > 0 ? (
                        <ChangesTable
                            fields={fields}
                            changes={changes}
                        />
                    ) : (
                        <Alert
                            type={"info"}
                            message={"No Results"}
                        />
                    )}
                </Space>
            )}
        </Modal>
    )
}